import { useState } from "react";
import { CalendarIcon, CreditCard, DollarSign, Users } from "lucide-react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import { AffiliateTable } from "./components/affiliate-table";

export default function AffiliateTracking() {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="tw-flex tw-min-h-screen tw-w-full tw-flex-col">
      <main className="tw-flex tw-flex-1 tw-flex-col tw-gap-4 tw-p-4 md:tw-gap-8 md:tw-p-8">
        <div className="tw-mb-2">
          <Typography variant="h5" fontWeight="bold">
            Your earnings
          </Typography>
        </div>
        <div className="tw-grid tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-4">
          <Card className="tw-shadow-md tw-rounded-lg tw-p-4">
            <Box className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-mb-2 tw-px-4 tw-pt-2">
              <Typography variant="h6" fontWeight="medium">
                Total withdrawal
              </Typography>
              <DollarSign className="tw-h-4 tw-w-4 tw-text-muted-foreground" />
            </Box>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                $4,231.89
              </Typography>
            </CardContent>
          </Card>
          <Card className="tw-shadow-md tw-rounded-lg tw-p-4">
            <Box className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-mb-2 tw-px-4 tw-pt-2">
              <Typography variant="h6" fontWeight="medium">
                Ready for withdrawal
              </Typography>
              <CreditCard className="tw-h-4 tw-w-4 tw-text-muted-foreground" />
            </Box>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                $2,350.45
              </Typography>
            </CardContent>
          </Card>
          <Card className="tw-shadow-md tw-rounded-lg tw-p-4">
            <Box className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-mb-2 tw-px-4 tw-pt-2">
              <Typography variant="h6" fontWeight="medium">
                Pending earnings
              </Typography>
              <CalendarIcon className="tw-h-4 tw-w-4 tw-text-muted-foreground" />
            </Box>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                $1,881.44
              </Typography>
            </CardContent>
          </Card>
          <Card className="tw-shadow-md tw-rounded-lg tw-p-4">
            <Box className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-mb-2 tw-px-4 tw-pt-2">
              <Typography variant="h6" fontWeight="medium">
                Total referrals
              </Typography>
              <Users className="tw-h-4 tw-w-4 tw-text-muted-foreground" />
            </Box>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                48
              </Typography>
            </CardContent>
          </Card>
        </div>

        {/* MUI Tabs */}
        <Box className="tw-bg-white tw-rounded-lg tw-shadow-md">
          <Tabs
            value={tabIndex}
            onChange={(_, newIndex) => setTabIndex(newIndex)}
            className="tw-border-b"
          >
            <Tab label="Referrals" className="tw-text-sm tw-font-medium" />
          </Tabs>

          {/* Tab Panels */}
          {tabIndex === 0 && (
            <Box className="tw-p-4">
              <AffiliateTable />
            </Box>
          )}
        </Box>
      </main>
    </div>
  );
}
